import { validate } from './validate';

const STUDIO_NAME_ACCOUNT_TYPES = ['studio', 'artistInStudio'];

function syncStudioNameVisibility(form) {
  if (!form) return;

  const accountType = form.querySelector('[name="fields[accountType]"]');
  const studioField = form.querySelector('[data-studio-name-field]');
  if (!accountType || !studioField) return;

  const studioInput = studioField.querySelector('[name="fields[studioName]"]');

  const sync = () => {
    const show = STUDIO_NAME_ACCOUNT_TYPES.includes(accountType.value);
    studioField.hidden = !show;
    if (!show && studioInput) {
      studioInput.value = '';
    }
  };

  accountType.addEventListener('change', sync);
  sync();
}

document.addEventListener('DOMContentLoaded', function () {
  validate(document.getElementById('checkout_login'), {
    rules: {
      loginName: ['required', 'email'],
      password: ['required'],
    },
  });

  validate(document.getElementById('checkout_continue'), {
    rules: {
      email: ['required', 'email'],
    },
  });

  const customerDetailsForm = document.getElementById(
    'checkout_customer_details'
  );
  validate(customerDetailsForm, {
    rules: {
      'fields[firstName]': ['required'],
      'fields[lastName]': ['required'],
      'fields[phone]': ['required'],
      'fields[accountType]': ['required'],
      'fields[studioName]': [
        ['requiredIf', 'fields[accountType]', 'studio'],
        ['requiredIf', 'fields[accountType]', 'artistInStudio'],
        'maxLength:50',
      ],
    },
  });
  syncStudioNameVisibility(customerDetailsForm);
});

// Sync create-account checkbox → checkoutAsGuest + registerUserOnOrderComplete
document.addEventListener('DOMContentLoaded', function () {
  const createAccountCheckbox = document.querySelector(
    '[data-checkout-create-account]'
  );
  const checkoutAsGuestInput = document.querySelector(
    '[data-checkout-as-guest]'
  );
  const registerUserInput = document.querySelector(
    '[data-register-user-on-complete]'
  );

  if (!createAccountCheckbox || !checkoutAsGuestInput) {
    return;
  }

  const syncAccountChoice = function () {
    const createAccount = createAccountCheckbox.checked;
    // Checked = create account = not guest + send activation email
    checkoutAsGuestInput.value = createAccount ? '0' : '1';
    if (registerUserInput) {
      registerUserInput.value = createAccount ? '1' : '0';
    }
  };

  createAccountCheckbox.addEventListener('change', syncAccountChoice);
  syncAccountChoice();
});
